export default {
  products: () => `/products`,
  getABPrice: (id) => `/product/${id}/ab`,
  getSMPrice: (id) => `/product/${id}/sm`,
  getCMPrice: (id) => `/product/${id}/cm`,
  getSSPrice: (id) => `/product/${id}/ss`,
  getInventory: (distributor) => `/${distributor}/inventory`,
  getMiscInventory: () => `/misc/inventory`,
  users: (id) => `/users/${id}`,
  vendors: (code) => `/vendors/${code}`,
  cart: () => `/cart`,
  cartAdd: () => `/cart/add`,
  cartWarehouses: () => `/cart/warehouses`,
  switchCart: () => `/cart/switch-cart`,
  saveCart: () => `/cart/save-cart`,
  checkoutDetails: (id) => `/checkout/${id}`, // TODO: remove in favor of checkout
  shippingMethodUpdate: (distributor) => `/shippingmethod/${distributor}`,
  checkout: (distributor) => `/checkout/${distributor}`,
  checkoutFinalize: (distributor) => `/checkout/${distributor}/finalize`,
  getShippingMethods: (distributor) =>
    `/checkout/${distributor}/shippingMethods`,
  getProductInfo: (dgiStyle) => `/styles/${dgiStyle}`,
  invoices: (userId) => `/${userId}/invoices`,
  invoiceStockStatusGet: (userId, invoiceId) =>
    `/${userId}/${invoiceId}/invoices`,
  orders: (userId) => `/orders/${userId}`,
  invoiceAutoAdd: (userId) => `/auto/${userId}/auto-add`,
  verifyPrintavo: (userId) => `/users/${userId}/verify-printavo`,
  getPrintavoStatuses: (userId) => `/users/${userId}/printavo-statuses`,
  createSubscription: () => `/subscription/create`,
  cartOptimize: (userId) => `/cart/${userId}/optimize`,
  postSetupIntent: () => `/payment/setup-intent`,
  manageSubscription: () => `/subscription/manage`,
  getPaymentMethodDetails: () => `/payment/method-details`,
  goUsers: (id) => `/users/${id}`,
  goProductInfo: (dgiStyle) => `/styles/${dgiStyle}`,
  vendorAgnosticCheckout: (distributor) => `/${distributor}/checkout`,
  vendorAgnosticShippingAddress: (distributor) =>
    `/${distributor}/checkout/shipping-address`,
  vendorAgnosticComplete: (distributor) => `/${distributor}/checkout/complete`,
};
